module.exports = __webpack_public_path__ + "img/art-12.8cd6877b.png";